// @flow
import React, { useState } from 'react'
import { Meteor } from 'meteor/meteor'
import trackEvent from '../lib/trackEvent'

import Button from './Button'
import { logout, openAlertDialog } from '../fonction'
import { formattedMessage } from '../CurrentLocale'
import AlertDialog from './Dialog'

type DeleteProps = {
  pro?: boolean,
  validated?: boolean,
  loading?: boolean,
}

const ButtonDeleteProfile = ({ loading = false, pro = false, validated = false }: DeleteProps) => {
  const [openDialogConfirm, setOpenDialogConfirm] = useState(false)

  const handleSubmitDelete = () => {
    trackEvent('DELETE_ACCOUNT')

    Meteor.promise('deleteAccount')
      .then((res) => {
        if (!!pro && !!validated && !res) {
          openAlertDialog({
            message: formattedMessage({ id: 'DeleteButton.message1' }),
            title: formattedMessage({ id: 'DeleteButton.messageTitle1' }),
          })
        } else {
          logout()
        }
      })
      .catch((error) => console.error(error))
  }

  return (
    <>
      <AlertDialog
        open={openDialogConfirm}
        onValid={() => handleSubmitDelete()}
        onClose={() => setOpenDialogConfirm(false)}
        message={
          !!pro
            ? formattedMessage({ id: 'DeleteButton.message2' })
            : formattedMessage({ id: 'DeleteButton.message3' })
        }
        buttonValid={formattedMessage({ id: 'yes' })}
        buttonClose={formattedMessage({ id: 'no' })}
      />

      <Button
        onClick={() => setOpenDialogConfirm(true)}
        loading={loading}
        color="secondary"
        title={formattedMessage({ id: 'delete' })}
      />
    </>
  )
}
export default ButtonDeleteProfile
